import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { parseCookies } from 'nookies'
import { SubmitHandler, useForm } from 'react-hook-form'
import getLocale from '_app/utils/localized/getLocale'
import { useRouter } from '_app/hooks/useRouter'
import { SET_SHIPPING_ADDRESSES_ON_CART } from '_app/graphql/mutations/cart/SetShippingAddressOnCart'
import { FAKE_ADDRESS } from '../../../checkout'

const useApplePay = () => {
  const [isApplePayModalOpen, setIsApplePayModalOpen] = useState(false)
  const { locale } = useRouter()
  const [setShippingAddressesOnCart] = useMutation(
    SET_SHIPPING_ADDRESSES_ON_CART
  )
  const { cartId } = parseCookies()
  const { handleSubmit } = useForm()

  const handleApplePayClick = async (onSubmit: SubmitHandler<any>) => {
    setIsApplePayModalOpen(true)
    await handleSubmit(onSubmit)()
    await setShippingAddressesOnCart({
      variables: {
        cartId,
        shippingAddresses: [
          {
            address: {
              ...FAKE_ADDRESS,
              country_code: getLocale(locale).toUpperCase(),
            },
          },
        ],
      },
    })
  }

  const handleModalClose = () => setIsApplePayModalOpen(false)

  return {
    isApplePayModalOpen,
    onApplePayClick: handleApplePayClick,
    onModalClose: handleModalClose,
  }
}

export default useApplePay
